import React from "react";
import { ActionModal, Modal } from "../../../secondary";
import { PERMISSIONS } from "../../../../constants/permissions";
import styles from "./signAndLock.module.scss";
import { useSignAndLock, MODAL_TYPES } from "./useSignAndLock";
import { SignedBadge } from "./SignedBadge";
import { SignButton } from "./SignButton";
import { SignDropdown } from "./SignDropdown";
import { LockButton } from "./LockButton";
import { ReEvalButton } from "./ReEvalButton";

export const SignAndLock = () => {
  const {
    signed,
    locked,
    isDischarged,
    isSign,
    pendingItems,
    signAndLockLoading,
    assessmentDetail,
    detailViewData,
    hasPermission,
    showModal,
    modalType,
    modalOpen,
    modalClose,
    viewDrop,
    dropRef,
    handleDrop,
    setIsSignAndLock,
    handleSign,
    handleContinue,
    handleReEval,
    handleReEvalMsg,
    handleContinueReEval,
  } = useSignAndLock();

  const showSignDropdown = hasPermission(PERMISSIONS.EXT_SIGN_LOCK) && !signed && !locked;
  const showSignButton = !hasPermission(PERMISSIONS.EXT_SIGN_LOCK) && !signed && !locked;
  const showLockButton = signed && !locked;
  const showReEvalButton = assessmentDetail?.titleNo !== 0 && !isDischarged && detailViewData?.skipPhoto === 1;

  return (
    <>
      <Modal modalOpen={showModal} modalClose={modalClose}>
        {modalType === MODAL_TYPES.RE_EVAL ? (
          <div className={`m-4 ${styles.modal_outer}`}>
            <span className={styles.close} onClick={modalClose}>
              X
            </span>
            <ActionModal
              heading={"The current wound assessment is not completed or signed. Do you wish to start a new assessment?"}
              buttonText={"Continue"}
              buttonAction={handleContinueReEval}
              buttonTextAlt={"Cancel"}
              buttonActionAlt={modalClose}
            />
          </div>
        ) : (
          <div className={`m-4 ${styles.modal_outer}`}>
            <span className={styles.close} onClick={modalClose}>
              X
            </span>
            {modalType === MODAL_TYPES.LOCK && (
              <ActionModal
                heading={"Are you sure you want to lock this assessment? Once locked, no changes can be made to this assessment."}
                buttonText={"Continue"}
                buttonAction={handleContinue}
                buttonTextAlt={"Cancel"}
                buttonActionAlt={modalClose}
              />
            )}
          </div>
        )}
      </Modal>

      {/* Signed / Signed & Locked badge */}
      {signed && <SignedBadge locked={locked} />}

      {/* Sign dropdown — EXT_SIGN_LOCK users only */}
      {showSignDropdown && (
        <SignDropdown
          isSign={isSign}
          pendingItems={pendingItems}
          viewDrop={viewDrop}
          dropRef={dropRef}
          onToggle={handleDrop}
          onSign={handleSign}
          onSignAndLock={(e) => {
            modalOpen(e, MODAL_TYPES.LOCK);
            setIsSignAndLock(true);
          }}
        />
      )}

      {/* Sign button — all other roles */}
      {showSignButton && (
        <SignButton isSign={isSign} pendingItems={pendingItems} disabled={!hasPermission(PERMISSIONS.SIGN) || !isSign} onSign={handleSign} />
      )}

      {/* Lock button */}
      {showLockButton && (
        <LockButton
          disabled={!hasPermission(PERMISSIONS.LOCK)}
          loading={signAndLockLoading}
          onLock={(e) => {
            modalOpen(e, MODAL_TYPES.LOCK);
            setIsSignAndLock(false);
          }}
        />
      )}

      {/* Re-Eval button */}
      {showReEvalButton && <ReEvalButton disabled={!hasPermission(PERMISSIONS.RE_EVAL)} onReEval={signed ? handleReEval : handleReEvalMsg} />}
    </>
  );
};
